// src/components/CustomAccordion.jsx
import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Typography,
  FormControlLabel
} from '@mui/material';
import { colorTextBlack } from '../../../config/theme';
import { IOSSwitch } from '../../../utils/styledLayout';

const CustomAccordion = ({ title, checked, onChange }) => (
  <Accordion
    bgcolor={'white'}
    elevation={0}
    expanded={false}
    sx={{
      backgroundColor: 'white',
      borderBottom: 'none', // remove bottom border
      '&::before': {
        display: 'none' // removes the default MUI divider line
      }
    }}
  >
    <AccordionSummary sx={{ height: 58, borderRadius: '8px' }}>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          margin: '7px 0px'
        }}
      >
        <Typography
          variant="body1"
          fontSize={'16px'}
          fontWeight={'600'}
          color={colorTextBlack}
        >
          {title}
        </Typography>
        <Box sx={{}}>
          <FormControlLabel
            sx={{
              marginRight: '12px'
            }}
            control={
              <IOSSwitch
                checked={checked}
                onChange={onChange}
                onClick={e => e.stopPropagation()}
              />
            }
          />
        </Box>
      </Box>
    </AccordionSummary>
  </Accordion>
);

export default CustomAccordion;
